// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';

import { getDataFromStorageUnit, setDataToStorageUnit, deleteStorageUnit } from '@shared/utils/common';

export const ENTITIES = {
  jobRequest: 'jobRequest',
  collection: 'collection',
  deliverable: 'deliverable',
  platform: 'platform',
  customerUser: 'customerUser',
  staff: 'staff',
  asset: 'asset',
};

const TEMPLATE_STORAGE_KEY = 'VI_templates';

type TemplateData = any;

@injectable()
export default class EntitiesTemplatesStore {
  static diToken = Symbol('entities-templetes');

  hasTemplate(entity: string) {
    const data = this.getTemplate(entity);

    return Boolean(data);
  }

  getTemplate(entity: string): TemplateData | undefined {
    return getDataFromStorageUnit(TEMPLATE_STORAGE_KEY)[entity];
  }

  setTemplate(entity: string, data: TemplateData) {
    setDataToStorageUnit(TEMPLATE_STORAGE_KEY, entity, data);
  }

  deleteTemplate(entity: string) {
    setDataToStorageUnit(TEMPLATE_STORAGE_KEY, entity, undefined);
  }

  reset() {
    deleteStorageUnit(TEMPLATE_STORAGE_KEY);
  }
}